import { Alert } from 'antd';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import i18n from '~/i18n';
import { CartActionContext } from '../Layout/providers/CartProvider';
import { OrderContext } from '../Layout/providers/OrderProvider';
import Header from '../components/Header';
import SpinnerOverlay from '../components/SpinnerOverlay';
import BottomBar from './components/BottomBar';
import SavedBottomBar from './components/BottomBar/SavedBottomBar';
import ListItem from './components/ListItem';
import TotalSection from './components/TotalSection';
import message from '~/utils/message';
import './style.css';
import Container from '../components/Container';
import StickyHeader from '../components/StickyHeader';
import FixedBottom from '../components/FixedBottom';
import { usePrintOrder } from '~/App/hooks';
import { api } from '@restaurant/api';

const Cart = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { order, setOrder, newOrder } = useContext(OrderContext);
  const [saved, setSaved] = useState(false);
  const [batchIndex, setBatchIndex] = useState<number | null>(null);
  const { getAllCartItems, resetCart } = useContext(CartActionContext);
  const { printOrderBatch } = usePrintOrder();

  const onSave = async () => {
    try {
      const items = getAllCartItems();
      if (!items.length) {
        throw new Error('Belum ada pesanan');
      }

      setLoading(true);

      let promise = null;

      if (order.isNew) {
        const { orderType } = order;
        if (!orderType) throw new Error('Order type is missing');

        promise = api.createOrder({
          orderType,
          tableNumber: order.tableNumber,
          customerName: order.customerName,
          items,
          delivery: order.delivery,
        });
      } else {
        promise = api.addOrderBatch(order.orderId, {
          items,
        });
      }
      const { orderId, batchIndex } = await promise;

      setSaved(true);

      const newOrder = await api.fetchOrderById(orderId);
      setOrder(newOrder);
      setBatchIndex(batchIndex);
    } catch (e: any) {
      message.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  const onPrint = async () => {
    if (order.isNew || batchIndex == null) {
      return;
    }
    setLoading(true);
    await printOrderBatch(order.orderId, batchIndex);
    setLoading(false);
  };

  const onHomeClick = () => {
    if (saved) {
      resetCart();
      newOrder();
      navigate('/', { replace: true });
      return;
    }
    navigate('/');
  };

  return (
    <Container>
      <StickyHeader>
        <Header
          title={i18n.t('cart_page_header')}
          onBack={() => {
            if (saved) {
              resetCart();
              newOrder();
              navigate('/', { replace: true });
              return;
            }
            navigate(-1);
          }}
          onHomeClick={onHomeClick}
        />
      </StickyHeader>
      {saved ? (
        <Alert message={i18n.t('message_success_save_order')} type="success" />
      ) : null}
      <div style={{ paddingBottom: 125 }}>
        <SpinnerOverlay show={loading} />
        <ListItem saved={saved} />
      </div>
      <FixedBottom>
        <TotalSection />
        {saved ? (
          <SavedBottomBar onPrint={onPrint} disabled={loading} />
        ) : (
          <BottomBar onSave={onSave} disabled={loading} />
        )}
      </FixedBottom>
    </Container>
  );
};

export default Cart;
